import { Toaster as Sonner } from 'sonner';
import { useThemeMode } from '../../shared/contexts/ThemeContext';
import { DURATION } from '../../shared/styles/animations';
import { SAFE_AREA_BOTTOM } from '../../shared/styles/layout.constants';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useThemeMode();

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      duration={4000}
      // The toast viewport is `position: fixed`, so its offset is measured from
      // the physical screen edge — which on an edge-to-edge Android shell is
      // behind the navigation bar. Sonner's own defaults (24px desktop / 16px
      // mobile) are both smaller than a navigation bar, so every toast rendered
      // partly underneath it, and a toast carrying an action button rendered
      // that button out of reach. Add the inset to each; both resolve to the
      // stock value wherever it is 0px.
      offset={{ bottom: `calc(24px + ${SAFE_AREA_BOTTOM})` }}
      mobileOffset={{ bottom: `calc(16px + ${SAFE_AREA_BOTTOM})` }}
      toastOptions={{
        classNames: {
          toast:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            // eslint-disable-next-line i18next/no-literal-string -- CSS class names, not user copy
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
        // Use centralized animation duration for consistency
        style: {
          '--toast-animation-duration': `${DURATION.slow}ms`,
        } as React.CSSProperties,
      }}
      {...props}
    />
  );
};

export { Toaster };
